import React, { createContext, useContext, useState, useCallback } from 'react';
import { VAPI_CONFIG } from '../config/vapi';

interface AuthContextType {
  isAuthenticated: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem('demoUser') !== null;
  });

  const login = useCallback(async (email: string, password: string) => {
    try {
      // For development/demo purposes
      if (email === 'demo@example.com' && password === 'demo123') {
        localStorage.setItem('demoUser', email);
        setIsAuthenticated(true);
        return;
      }

      const response = await fetch(`${VAPI_CONFIG.API_ENDPOINT}/auth/login`, {
        method: 'POST',
        ...VAPI_CONFIG.API_OPTIONS,
        body: JSON.stringify({ email, password })
      });

      if (!response.ok) {
        throw new Error('Invalid credentials');
      }

      const data = await response.json();
      localStorage.setItem('demoUser', email);
      setIsAuthenticated(true);
    } catch (error) {
      console.error('Login error:', error);
      throw new Error('Login failed. Please check your credentials and try again.');
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('demoUser');
    setIsAuthenticated(false);
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};